// storage.ts (utility file for configuring Ionic storage)
import { Storage } from '@ionic/storage';

const storage = new Storage();
storage.create(); // This creates the storage engine.

export default storage;
